import React from "react";
import HeaderTop from "../components/Headertop";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import Contactdetails from "../components/Contactdetails";
import HeroSection from "../components/HeroSection";

function Contact(){
    return(
        <>
            <HeaderTop />
            <Navbar />
            <HeroSection />
            <Contactdetails />
            <Footer />
        </>
    );
}
export default Contact;